import React from 'react';
import './login_card.css'
import logo from '../../assets/logo.png'
import Input from './input';
import CTA from './cta';
import { Link } from 'react-router-dom';
import { useState } from 'react';


const Logincard = () => {


 const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [errors, setErrors] = useState({});






const isValidLogin =
    username === 'salmayasser' && password === '123456';





    return ( 
        <article className='logincard-container'>
                <article className='sub-cont1-login'>
                    <img src={logo} alt='logo'></img>
                    <h3 className='para-login'>Sign in to access the admin dashboard</h3>
                </article>

                <form className='form'>
                      <Input 
                    title='UserName'
                    placeholder='Enter your username'
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    error={errors.username}
                />

                        <Input 
                            title='Password'
                            placeholder='Enter your password'
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            error={errors.password}
                        />
                    <fieldset className='big-cont-remember-me'>
                            <fieldset className="checkmark-cont">
                            <label className="custom-checkboxl">
                                <input type="checkbox" />
                                <span className="checkmark"></span>
                                <h3 className="rememberme">Remember me</h3>
                            </label>
                            </fieldset>

                        <h2 className='forgot_password'>Forgot password?</h2>
                    </fieldset>



                            <Link
                                to={isValidLogin ? "/home-page" : "#"}
                                className="link"
                                onClick={(e) => {
                                    let newErrors = {};

                                    if (!username.trim()) {
                                        newErrors.username = 'Username is required';}
                                    if (!password.trim()) {
                                        newErrors.password = 'Password is required';}

                                    if (!isValidLogin) {
                                        newErrors.username = 'Invalid username or password';
                                    }
                                    if (Object.keys(newErrors).length > 0) {
                                        e.preventDefault(); 
                                        setErrors(newErrors);
                                    }}}>
                             <CTA title='Sign In'/>
                        </Link>


                </form>

                <h3 className='copyrights'>© 2026 Musicticket. All rights reserved.</h3>
        </article>
     );
}
 
export default Logincard;